/**
 * Api
 *
 */
import axios from 'axios'
import Status from 'http-status'
import { FLAG_LOCAL_STORAGE_TOKEN } from './Flags'
import { apiHost } from './Env'

let userData = {
  iId: -2,
  iIdProveedor: -2,
}

class Api {
  static host = apiHost.startsWith('http')
    ? apiHost
    : `${window.location.protocol}//${apiHost}`

  static pageSize = 25

  /**
   * To Url
   *
   * @param {String} path
   */
  static to(path) {
    const url = `${this.host}/${path[0] === '/' ? path.substr(1) : path}`
    if (process.env.NODE_ENV === 'development') {
      console.info('[API.TO]', url)
    }
    return url
  }

  /**
   * To Url
   *
   * @param {String} path
   */
  static image(name) {
    return `${this.host}/api/file?type=image&name=${name}`
  }

  /**
   * getUserId
   */
  static getUserId() {
    return localStorage.getItem(FLAG_LOCAL_STORAGE_TOKEN) || null
  }

  /**
   * getProviderId
   */
  static getProviderId() {
    return userData.iIdProveedor
  }

  /**
   * setUserData
   *
   * @param {*} newData
   */
  static setUserData(newData) {
    localStorage.setItem(FLAG_LOCAL_STORAGE_TOKEN, newData.iId)
    userData = {
      ...userData,
      ...newData,
    }
  }

  /**
   * setUserData
   *
   * @param {*} newData
   */
  static getUserData() {
    return userData
  }

  /**
   * removeUserData
   *
   * @param {*} newData
   */
  static removeUserData() {
    localStorage.removeItem(FLAG_LOCAL_STORAGE_TOKEN)
    userData = {
      iId: null,
      iIdProveedor: null,
    }
  }

  /**
   * headers
   *
   * @return Object
   */
  static headers(data) {
    const token = this.getUserId()
    const contentType = data instanceof FormData ?
      'multipart/form-data' :
      'application/json'

    const common = {
      'X-Requested-With': 'XMLHttpRequest',
      'App-User-Id': token,
      'App-Client': 'web',
    }

    return token ? {
      'Authorization': token,
      'Content-Type': contentType,
      ...common

    } : {
      'Content-Type': contentType,
      ...common
    }
  }

  /**
   * GET
   *
   * @param string path
   * @param Object params
   */
  static get(path, params = {}) {
    return axios({
      method: 'GET',
      headers: this.headers(),
      url: this.to(path),
      params,
    })
  }

  /**
   * POST
   *
   * @param {string} path
   * @param {Object} data
   * @param {import('axios').AxiosRequestConfig} config
   */
  static post(path, data, config = {}) {
    return axios({
      method: 'POST',
      headers: this.headers(data),
      url: this.to(path),
      data,
      ...config
    })
  }

  /**
   * PUT
   *
   * @param string path
   * @param Object data
   * @param {import('axios').AxiosRequestConfig} config
   */
  static put(path, data, config = {}) {
    return axios({
      method: 'PUT',
      headers: this.headers(data),
      url: this.to(path),
      data,
      ...config
    })
  }

  /**
   * DELETE
   *
   * @param string path
   * @param Object data
   */
  static delete(path) {
    return axios({
      method: 'DELETE',
      headers: this.headers(),
      url: this.to(path),
    })
  }

  /**
   * Cargar archivo
   *
   * @param {File} file
   */
  static form(values) {
    var data = new FormData()
    const keys = Object.keys(values)

    for (let idx = 0; idx < keys.length; idx++) {
      data.append(keys[idx], values[keys[idx]])
    }

    return data
  }

  /**
   * GET
   *
   * @param string path
   * @param Object params
   * @param {import('axios').AxiosRequestConfig} config
   */
  static query(query, extraHeaders = {}, config = {}) {
    return axios.post(this.to('/kernel/query', query), query, {
      headers: this.headers(extraHeaders),
      ...config
    })
  }

  /**
   * Procesa un código de error a texto
   *
   * @param {Int} code
   */
  static statusCodeToString(code) {
    if (code === Status.BAD_REQUEST) {
      return 'Petición erronea'
    } else if (code === Status.CONFLICT) {
      return 'Conflicto de información'
    } else if (code === Status.UNAUTHORIZED) {
      return 'No autorizado'
    } else if (code === Status.NOT_FOUND) {
      return 'No encontrado'
    } else if (code >= Status.INTERNAL_SERVER_ERROR) {
      return 'Servicio no disponible'
    } else if (code >= Status.INTERNAL_SERVER_ERROR) {
      return 'Servicio no disponible'
    } else {
      return 'Solicitud no procesada'
    }
  }
}

/**
 *
 * @param {*} query
 * @param {*} extraHeaders
 * @param {import('axios').AxiosRequestConfig} config
 * @returns
 */
Api.query.list = (query = {}, extraHeaders = {}, config = {}) => {
  return axios.post(Api.to('/kernel/query/list'), query, {
    headers: Api.headers(extraHeaders),
    ...config
  })
}

/**
 *
 * @param {*} query
 * @param {*} extraHeaders
 * @param {import('axios').AxiosRequestConfig} config
 * @returns
 */
Api.query.first = (query, extraHeaders = {}, config = {}) => {
  return axios({
    method: 'GET',
    headers: Api.headers(extraHeaders),
    url: Api.to('/kernel/query'),
    params: {
      query: {
        ...query,
        __returnType: 'one',
      },
    },
    ...config
  })
}

export default Api
